(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/components/animated-background/animated-backgrounds.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/components/animated-background/animated-backgrounds.js');
'use strict';

const tickets = svs.tickets;
const AnimatedBackgrounds = _ref => {
  var _window$matchMedia;
  let ticketInfo = _ref.ticketInfo;
  const animatedBackground = tickets.next.components.animatedBackground;
  const backgroundMap = {
    balloons: animatedBackground.BalloonsBackground
  };
  const prefersReducedMotion = Boolean((_window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)')) === null || _window$matchMedia === void 0 ? void 0 : _window$matchMedia.matches);
  if (prefersReducedMotion || !ticketInfo) {
    return null;
  }
  const Background = backgroundMap.balloons;
  if (typeof Background !== 'function') {
    return null;
  }
  return React.createElement(Background, {
    ticketInfo: ticketInfo
  });
};
setGlobal('svs.tickets.next.components.animatedBackground.AnimatedBackgrounds', AnimatedBackgrounds);

 })(window);